/**
 * Central configuration for AI agents and models
 * Used by: ProjectSettings, AnalyzeModal, ImplementModal
 */

// AI Agent providers
export const AI_AGENTS = {
  CURSOR: 'cursor',
  CLAUDE: 'claude'
};

// Cursor Agent models (from `agent models` CLI output)
export const CURSOR_MODELS = [
  { id: 'auto', name: 'Auto (Recommended)' },
  { id: 'opus-4.5-thinking', name: 'Claude 4.5 Opus (Thinking)' },
  { id: 'opus-4.5', name: 'Claude 4.5 Opus' },
  { id: 'sonnet-4.5', name: 'Claude 4.5 Sonnet' },
  { id: 'sonnet-4.5-thinking', name: 'Claude 4.5 Sonnet (Thinking)' },
  { id: 'composer-1', name: 'Composer 1' },
  { id: 'gpt-5.2-codex', name: 'GPT-5.2 Codex' },
  { id: 'gpt-5.2-codex-high', name: 'GPT-5.2 Codex High' },
  { id: 'gpt-5.2-codex-fast', name: 'GPT-5.2 Codex Fast' },
  { id: 'gpt-5.2', name: 'GPT-5.2' },
  { id: 'gpt-5.2-high', name: 'GPT-5.2 High' },
  { id: 'gemini-3-pro', name: 'Gemini 3 Pro' },
  { id: 'gemini-3-flash', name: 'Gemini 3 Flash' }
];

// Claude API models (from Anthropic docs)
export const CLAUDE_MODELS = [
  { id: 'claude-sonnet-4-5-20250929', name: 'Claude Sonnet 4.5 (Recommended)' },
  { id: 'claude-opus-4-5-20251101', name: 'Claude Opus 4.5' },
  { id: 'claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5' }
];

// Get models for a specific agent
export const getModelsForAgent = (agent) => {
  return agent === AI_AGENTS.CLAUDE ? CLAUDE_MODELS : CURSOR_MODELS;
};

// Get default model for an agent
export const getDefaultModelForAgent = (agent) => {
  if (agent === AI_AGENTS.CLAUDE) {
    return 'claude-sonnet-4-5-20250929';
  }
  return 'auto';
};
